import { Badge } from '@/components/ui/badge';
import { EOS_TODO_STATUS_LABELS, type EosTodoStatus } from '../types';

const VARIANT: Record<EosTodoStatus, 'default' | 'secondary' | 'outline' | 'destructive'> = {
  open: 'default',
  done: 'secondary',
  cancelled: 'outline',
};

export function TodoStatusBadge({ status }: { status: EosTodoStatus }) {
  return <Badge variant={VARIANT[status]}>{EOS_TODO_STATUS_LABELS[status]}</Badge>;
}
